import { initialStateData } from 'shared/state';

import { ReportConfigSchema } from './ReportConfig.schema';

export const state: ReportConfigSchema = {
  configChanges: initialStateData,
};
